import { render } from "./DiscoverAlbum.vue?vue&type=template&id=94efd914&scoped=true"
import script from "./DiscoverAlbum.vue?vue&type=script&lang=js"
export * from "./DiscoverAlbum.vue?vue&type=script&lang=js"

import "./DiscoverAlbum.vue?vue&type=style&index=0&id=94efd914&scoped=true&lang=css"

import exportComponent from "/Users/macbook/Mubasher/Mubasher/Projects/Live/bling-rock/Project-Live/soundcode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94efd914"]])

export default __exports__